var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('h1',{class:_vm.$style.title},[_vm._v("\n    The page timed out while loading. Are you sure you're still connected to the Internet?\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }